import { useState } from 'react'
import { v4 as uuid } from 'uuid'

import type { CreateInventoryOrderItemReceiptInput } from '~/api/graphql/generated/types'

import { useReceiptFields } from './useReceiptFields'

const DEFAULT_DRAFT_RECEIPT: CreateInventoryOrderItemReceiptInput = {
  receivedQuantity: null,
  lotNumber: null,
  expirationDate: null,
  serialNumber: null,
  damagedReasonId: null,
  damageNotes: null,
  businessReferenceNumber: null,
}

export const useDraftReceipts = () => {
  const [draftIds, setDraftIds] = useState<string[]>([])
  const { receiptFields: draftReceiptFields, validate } = useReceiptFields(
    draftIds.map((id) => ({
      id,
      ...DEFAULT_DRAFT_RECEIPT,
    })),
  )

  const addDraftReceipt = () => {
    setDraftIds([...draftIds, uuid()])
  }

  const deleteDraftReceipt = (id: string) => {
    setDraftIds(draftIds.filter((draftId) => draftId !== id))
  }

  const getDraftReceiptsForSubmission =
    (): CreateInventoryOrderItemReceiptInput[] =>
      draftReceiptFields.map(({ fields }) => ({
        receivedQuantity: fields.receivedQuantity.value,
        lotNumber: fields.lotNumber.value,
        expirationDate: fields.expirationDate.value,
        serialNumber: fields.serialNumber.value,
        businessReferenceNumber: fields.businessReferenceNumber.value,
        ...(fields.damaged.value
          ? {
              damagedReasonId: fields.damageReasonId.value,
              damageNotes: fields.damageNotes.value,
            }
          : {}),
      }))

  return {
    draftReceiptFields,
    addDraftReceipt,
    deleteDraftReceipt,
    validateDraftReceipts: validate,
    getDraftReceiptsForSubmission,
  }
}
